export default [
  {
    id: "rec18T7VqM6wSXvq0",
    name: "Keys to the Kingdom",
    description:
      "Jesus gave Peter the keys to the kingdom, and now we're giving them to you, for $20. This is basically the same thing, except you don't get to be the pope. So really, it’s nothing like Jesus giving Peter the keys. It's a pretty rad shirt though.",
    attachments: [
      {
        id: "attSqXPJXwLcLg66k",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/QyFmo5stXY0bsdQQSmqIlA/X9Ib_3KQmJBxp2lcxCD7iNP8WdW6whA2QeuSxU8z7wQnx98u89gDdtYtoDXVkiAa41zc6JcujdpbnbirMEdGa04kc4amgqGdcqgowSNf3Uc/Npasj-QqRlkx0fIhD86Ed7qXeUXUkRVCsEj1w5Oq16k",
        filename: "shirt-keys.jpg",
        size: 86354,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/I6GxSi_hdn0c5AVRIu1iRw/FxK3Zvg-JnvcFfmO5_aEbatyd2rQVu-x228ROphd2r7zO_HIABtHN2MVfJg3khnqF2EEzNXvivk5KGker0pshtYtr8TroagumPWrMDqisHs/SxN37hsQsqByP3h8rejOx8E8kAbNMIxBZ8W_aYs-aQY",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/fnaehEesSrrKE5Lc8bkaAQ/IATVjGcbsWj_fX3_TPBncmxwslC-yTkeP5EssxkeeolyZMLzrqA02b1kZBwS6op28s1AA5l1I2UgRm60_HMPMK3KInZuZfoROes-tdpv3g4/I9sKJ18eHYNTXbxNGPowix_ZZnsmV1N_VDR5aWbO0L4",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/Vgy_CNXqCtxFjhyvm0jFIA/VRSWTb0P2t0aEVl4WbA0VM-9zRtk3iDf8fZUKKz7KFa0y32Sdj2pcCDTgTpURyGwkR2v4KL6kbMrzkX2Yt49sVF4TvcBhPkJ3aeFpus5A00/EgC5dKmWdXmhgoY1a_sAHzO33hpW7SS5lqVB0U3JHC8",
            width: 1000,
            height: 1000
          }
        }
      },
      {
        id: "attrIIzd8lPbQn2hj",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/ywHbcP5BPBMvQeW9NhyNEw/xSdZ8vljd-AJohnwTKXRAamqlscuGJNZYVdL5lva5Qifuyg_85C3-BLubRDk83lNrNb2v_iHWpIMl_8RV9m_DFlQL-a2VXwr3H5NxOWRq1c/9iBecP-jJshdTTEyGriaWTjiVRodp1ReWinwELnqzyc",
        filename: "shirt-detail.jpg",
        size: 112331,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/eNfgpGpDYp0UcMBF47hPSw/ohrjiiK_h-YaX5ZzuMFhOI8sMZCtvwkmPUjx8p4ufJBIoC1-Fwe2R3dxZ6WkhuzBEmItj_WH1_mFtEEkSbd0Xy3rAEihN7iyqma_m8rJHoI/irIOqgIrzGpNZxxKR8eoOSiK6SlHL9NxqIISCfIuvE4",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/xml6IK_iyqa6OJ4a_5n0iQ/BmNoElrZ7v_JsKudODq68iYyEjcomVnnTyXrU01vfnjlOXJfmA4o13Bet9uctOopXUdco5UKcFtAcg1DAyrqq-JLVCLX9kMAqLEGP-mwOVk/t7PgGa0aMwrdDTogmadKK2WyZ0mIVyXuMP3s7Uuqusc",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/bs-hnKb-9AgPUpmDT2DVfw/7M5bE7SbwvQI6xIaC0kzdb3Zuc08_y3-D8NLJ8-fRjSpZLTxpiQ6oDCrkLjzx9EtB3uzK-rtUpFjt4S1TjAtMAb64E-jCcUX0AcNVIqgq7k/A-zfrEqdbodu-AtDSBIUIOkBk9coUBO96zC-b9yHHwk",
            width: 1000,
            height: 1000
          }
        }
      }
    ],
    price: 10,
    recommendation_2: "wash on cold and dry with low heat",
    feature_2: "has a hole for your head",
    primary_photo: [
      {
        id: "attmkAt7gLgYwVsNy",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/6EjBDG1iEXqqiWgMnJJ5HA/CTTwRNMvxNmTVEkrQSs7ZB4WAxYG0OIC2gF42gkyyJ-VwstLxVBGAPOtJaUY_9Ft5_BcurbzHP_jg6RccM6Sq56VHU-_oBQexBkT2d4Na9k/eroi3-FSXrODPqAVvOgKfCS_dGg4lBQzE3GA_K2OMUc",
        filename: "shirt-keys.jpg",
        size: 86354,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/weS6LZqKhLQxAio3h76iyA/k9TYGQZLFLs_m7iCjMDhDLNsINi7D8jHJqi7oBmBp8aXOFz_uuRPj3YgSp127e8drnS_iSIOtRTS64Vb1EYGs4kXgIPDGyQmPPFl2CxAmz8/EAEHtSkpLSDGfuD2TKexqOBQKdSJuPrvQCl5fArXJh0",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/tL_omyxD73JhLuMF9XxlDw/BO2NIKzE4iNMcwOI3sdPIOfC-wEdmRzSGmWxOjUa7WTrowgZq_gXZiDRdGyi_qF5XNhZFwQCCMv8_YXZqqM9o5fVuytPTdqkrqxpLW4zZNg/bUoXfwhr8Vd6KXKAhiEGqaN5HXnaPb89mZvrwSoKZ_c",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/wsMgig2gIgNaaUmvkIpnLQ/wwKSZRMZb_0ePT5SgURuzuGxTP1V3sOoHrPx0_NpUA_YT2L26gpIe2oBAF3LnjUE5oXw3_lOygBm696cAfFMbCJO7q5-EmNf_E97Pziks1c/kh09_AQz14aPdhEggZtAz6H5o9OMcYRqNvz9BLlMFis",
            width: 1000,
            height: 1000
          }
        }
      }
    ],
    episode: ["recmUBNcwjOKAGc13"],
    category: ["Clothing"],
    variants: [
      {
        id: "recTSCw7ued6pD7vS",
        name: "S",
        description: "Small",
        order: 0,
        product: ["rec18T7VqM6wSXvq0"],
        remaining: 7,
        quantity: 9,
        "Order Lines": ["rec2NUigfAQq2460N"]
      },
      {
        id: "reca5dqhY1MvfpIpM",
        name: "M",
        description: "Medium",
        order: 1,
        product: ["rec18T7VqM6wSXvq0"],
        remaining: 14,
        quantity: 18,
        "Order Lines": [
          "recPxGOZnbctDlHLK",
          "recCLvZKIF7IqeUiN",
          "rec6QJAiF2CzwLETi",
          "recIUWXy8ZvA2hfQb"
        ]
      },
      {
        id: "rec5o1FOF9MXwmpWT",
        name: "L",
        description: "Large",
        order: 2,
        product: ["rec18T7VqM6wSXvq0"],
        remaining: 10,
        quantity: 19,
        "Order Lines": [
          "rec8WyRMbr27E8BaX",
          "rec2KCoR5xqKiBDGx",
          "recQu5SSYV7mIuNQQ",
          "recOJN5ayCOimiOHa",
          "recMzeTLF92LicDoU",
          "recz5ArvXg3LHhgk8"
        ]
      },
      {
        id: "recSSdNdB7drZOTPr",
        name: "XL",
        description: "Extra large",
        order: 3,
        product: ["rec18T7VqM6wSXvq0"],
        remaining: 2,
        quantity: 6,
        "Order Lines": [
          "recqXzGhlwrCJk7gH",
          "recN9duPc5O6qrcjz",
          "recazdcISnI8kYr1f",
          "receiXUi6BUkGMSfP"
        ]
      },
      {
        id: "recFCWm0ks3UuZqfn",
        name: "XXL",
        description: "Extra extra large",
        order: 4,
        product: ["rec18T7VqM6wSXvq0"],
        remaining: 0,
        quantity: 2,
        "Order Lines": ["rec6z7sTFDIHziDub", "recWAA56pAP2usjQ9"]
      }
    ],
    price: 20,
    feature_1: "has two sleeves",
    feature_2: "has a hole for your head",
    feature_3: "will make you look 7x70 cool",
    recommendation_1: "place directly on body to cover torso area",
    recommendation_2: "wash on cold and dry with low heat",
    recommendation_3: "give as gift to priest or loved one",
    primary_photo: [
      {
        id: "attmkAt7gLgYwVsNy",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/6EjBDG1iEXqqiWgMnJJ5HA/CTTwRNMvxNmTVEkrQSs7ZB4WAxYG0OIC2gF42gkyyJ-VwstLxVBGAPOtJaUY_9Ft5_BcurbzHP_jg6RccM6Sq56VHU-_oBQexBkT2d4Na9k/eroi3-FSXrODPqAVvOgKfCS_dGg4lBQzE3GA_K2OMUc",
        filename: "shirt-keys.jpg",
        size: 86354,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/weS6LZqKhLQxAio3h76iyA/k9TYGQZLFLs_m7iCjMDhDLNsINi7D8jHJqi7oBmBp8aXOFz_uuRPj3YgSp127e8drnS_iSIOtRTS64Vb1EYGs4kXgIPDGyQmPPFl2CxAmz8/EAEHtSkpLSDGfuD2TKexqOBQKdSJuPrvQCl5fArXJh0",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/tL_omyxD73JhLuMF9XxlDw/BO2NIKzE4iNMcwOI3sdPIOfC-wEdmRzSGmWxOjUa7WTrowgZq_gXZiDRdGyi_qF5XNhZFwQCCMv8_YXZqqM9o5fVuytPTdqkrqxpLW4zZNg/bUoXfwhr8Vd6KXKAhiEGqaN5HXnaPb89mZvrwSoKZ_c",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/wsMgig2gIgNaaUmvkIpnLQ/wwKSZRMZb_0ePT5SgURuzuGxTP1V3sOoHrPx0_NpUA_YT2L26gpIe2oBAF3LnjUE5oXw3_lOygBm696cAfFMbCJO7q5-EmNf_E97Pziks1c/kh09_AQz14aPdhEggZtAz6H5o9OMcYRqNvz9BLlMFis",
            width: 1000,
            height: 1000
          }
        }
      }
    ],
    variant_label: "Sizes",
    "Order Lines": [
      "rec6z7sTFDIHziDub",
      "recqXzGhlwrCJk7gH",
      "rec2NUigfAQq2460N",
      "recWAA56pAP2usjQ9",
      "rec8WyRMbr27E8BaX",
      "rec2KCoR5xqKiBDGx",
      "recN9duPc5O6qrcjz",
      "recPxGOZnbctDlHLK",
      "recCLvZKIF7IqeUiN",
      "recQu5SSYV7mIuNQQ",
      "recOJN5ayCOimiOHa",
      "rec6QJAiF2CzwLETi",
      "recMzeTLF92LicDoU",
      "recazdcISnI8kYr1f",
      "receiXUi6BUkGMSfP",
      "recz5ArvXg3LHhgk8",
      "recIUWXy8ZvA2hfQb"
    ],
    active: [true],
    primaryPhoto:
      "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/tL_omyxD73JhLuMF9XxlDw/BO2NIKzE4iNMcwOI3sdPIOfC-wEdmRzSGmWxOjUa7WTrowgZq_gXZiDRdGyi_qF5XNhZFwQCCMv8_YXZqqM9o5fVuytPTdqkrqxpLW4zZNg/bUoXfwhr8Vd6KXKAhiEGqaN5HXnaPb89mZvrwSoKZ_c",
    features: [
      "has two sleeves",
      "has a hole for your head",
      "will make you look 7x70 cool"
    ],
    recommendations: [
      "place directly on body to cover torso area",
      "wash on cold and dry with low heat",
      "give as gift to priest or loved one"
    ]
  },
  {
    id: "recMs9PjrASr12eNo",
    name: "Sticker Pack",
    description:
      "You can never have enough stickers. Put them on your laptop, your car, your water bottle, your dog, or your sister. We don't care - we're just happy you like them as much as we do.",
    attachments: [
      {
        id: "attjRTAoUYk6U9aPp",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/8MxMEkjjdP_nmURONHtYDg/TaQOakQ4Z8t679010sTZiGVppVzjwzOXTDNv8oC30nhI8CMXRoZKft4o3a9IpISH6HLR2U2LWS04rEY8t8wkcFCxq99eGqraf-Mdbovn7W4/BqTNp6VYSIjoNaT0LMILp_qcKqRoqKtCMH7yQ4Dn6pQ",
        filename: "stickers-group.jpg",
        size: 130895,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/IMSj5PTeTeCA99j0faCiYA/dFeEoGB2WhNAXUDmd9f7BG4KxsTG1sdJHRVToWRceMo_ZkSFfH__vOwyo5pJ0f5GigYwNeNDjYrNBEv-8OLsu8Taei-nyd7JMXE-oxFN4jCM4Fjh8HHkapKG1hBxSRJP/qJ0xox-bAAXgSKKBNxqfcj1S10d1yr7bmHcLEYrNChc",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/IyXrOSTZ9oYz2MTbct8Y8A/gGraNXmCpVjUJRIGo32jrryd12-eozNFZJTfyGVUX_cMn8Oug50wS8v3Wyb8XGQmcud7EYYW0r4WmFhcJh-wNSdpSyYAWYytid7PH2abP6av-cMFyVZq9uQRyq1y4LLM/9H6Q_jgtiLuIHWO6D6oE7gcNqx5BrY1oepwjsAfz-Do",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/TtAb8olbQnEH-VnwyTlgTw/ULt3DCTpUiDR5XdSf-VwFTxJ5q90xp2tqI3XPlv3GsgO33lQjlsh_ySoyRv42vKDJI834odk7YvLAeD0IyFY5MLQv25FsA-QPVQHgjV85ElXjdkfn4gyO1MCoIFN_Tjl/WrZJLvbshvQeYtViCwp87bPKdzt6oDc0yukFsCcu74s",
            width: 1000,
            height: 1000
          }
        }
      },
      {
        id: "attOk5gV0awzMP7Kg",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/yAX9tLWfMihBfXDpjvY6lQ/UcbjY2esId4NQV-L0BMzTDNSmxZMUL6WpERpE4EAforpScpInQOdfr6rQWGN8BJ_8EAjIC7L7KcCeMS2WQM7LSK3XVe67Iuacy6ytiPL1NQ/3FbaJ4Lj96nIGRhJnar2ZVKF31UazQ6ey3Uj6WMUtAI",
        filename: "sticker-mitre.jpg",
        size: 61994,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/qtbT034nSvshcNMBSXOi7A/40TNtZUE-9JcZnM8vV0oCOxsq52FB6Zso5kWE8ulfcDGAkEcgwXf8CBC6tfEMm-mJ7hcGn39VpRpKCO6Jmc7sZQkAG63zOa9uz8nD6D7hRw6mZd_nqz_RiIFEnN6Xd4o/aaw0ayzuf1XZ10OZV7AQq8A0sl0j7qdILSynljkRhbk",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/X_pYopK4x2EKWA6sWGOUCg/4FL3nxm9XuHNAn08eJOUoKzVE2QWYEbQmGg5xc8DNd5pHaFCXQgyJToIWmalZjEQLEN7uOYVVy-52T4uQ_Bbokp6gek9XR2bq3fRf1MgCEgMObJ88UkMpIpv5WSVqytu/bOmAzBqHXScwzMMUbfbsQTO8flOnirHoEPdLDTERCWY",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/M-TDlqvSOwisR31h9RFnlw/wMval-QL-KbMRICahamuGomWFeT6F6s3Mb55N8j0iYPmrIOMxKBwdevTuFhhCuKOI7fB2THCegmQzagIgs5cEDyipSAcIp_r_psY-akUb6c/Fe3Ptl6T8mgrP4m9Sy4ek21ymnUv7hwznTN-xiPAnRA",
            width: 1000,
            height: 1000
          }
        }
      },
      {
        id: "att5MqZ9z7wqozVXP",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/QGr1SONzAxnaCbfSosF9RA/cQjw_C-pDakxYQjUa9FGFK21cmr7ucKrnU-T5YNA0UChqfoHl-IIKWMkBFgRUbNhBu0BZbLQ8sAZBPM1tt6fctLT81zo3s8R0Kc7JlKQeGI/u9lQ-Wm1hamO08qC_YkkAlSql76QVvaiYuvMz06DmZc",
        filename: "sticker-card.jpg",
        size: 43816,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/Lsa7vZUZGh6uD--SHUacKw/FjOQG7-OWOGTkWDbEM32_NmI38cQpvrSZdto0U-VapWiCGtMGYU24RQS13Br4myeCNbZ7rR1YPGpQV04sEFTfaHJYfViRcFZ0sSQjjIoAPg/YDwn0ZxJ7mdMkg2qmitH2OkIol56LM1IG2P0B82V05Y",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/spsnSMQoUjKBZ-epSwr0Dw/bQFo__9vP7s9u5pNo_5s6TucAb28vwDUOuemFnzOjChfb66Gy3vx4V-enBcwZUV7Rev224RXRazOo5pIZWnOrq-eTQK5-evEWCDtBjKVNyk/DiSGAaKp-XGhyTKV8U9S-xkcvAyyAcXy-r1VboMO1LM",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/HGhNheHZ_P5SEWj9KTP5rA/3nH2khS3ukcxx-h5e7uQpN04beGzZzcZ2q4GsqGDDgdg6ZYgekU8uZFL5Ev1ZmZcHEN4wKhmJcd4Se_0cZK-upuZtgpw1S24ka5xQcaL3ko/qgeJ6KHcuZOMHOMIuf6L5aboj80cEZABjmlTX1p9NFA",
            width: 1000,
            height: 1000
          }
        }
      },
      {
        id: "atttKnenoY9P92go5",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/bkF4YQwvh8Uhif0VfxgRbg/jRcrP_FaRERZLRolYKaqWgt1ogYCDXUHqrJus4BHmVFid5NaHVUYfDu6UO7RJcH4P8BvZddsmR0s6LJpcyfMqqShhf9R8Gw49cCtsKQf_98/CGDRI3gWWI6CxHdCTwrMkYYl5oHiHoSAcHlkQIeJWgc",
        filename: "sticker-supreme.jpg",
        size: 48323,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/cVRs3E0aRel4yd6NtPI8lw/x0X1OtqMfliCuqbq1saHH9dJRv3iU8OSSv_CbvS7zkEU-1ExekZ8PKur1QR6VmnpNPvDatP1KHfzYv3k60gO9O7Tl_AHRpZtMO2dobVXo_v_QNokZ4-Zxgkgrr9EKE9c/c0gXR-cmwI2OXeViIMpXR22EyzGndx-qgCiFtVexzds",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/5_AtfYWL_RV0zJFoxWeVQw/5eHefIZzk-9kiAZoVQOLKIb7wUQ19DJpF6CRwOv4C8d2JJmFzDOmVlQ0KsV5JiSQmpedafqavKXOt87TufzolCrsYDn7vWk3g3ATVCDI1ViiUueP43OUUaKhaRkJOkvh/Ei2ciZ3koouPJWgUFa4MNjszMGfnVQ8m7qAT8IO7bqk",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/qCUGS6-0ZlapuC-o8k7Jhw/3eMDHI2BEjhLSYpYb2uRXv7M2EXhnOhj9YuDEVfzDyD-Et6DPl0UaCuVZuL2q3_8HuCTV-1Hgu1ap6Vzd0J98Vc6hUbB0Q6oPrc5S-D3I1whIi5Nzwk71cZ8NI5WGqn2/l4V4p6kgaed3AHz68wAIpkybOQCHBknOgeadxrIhtTY",
            width: 1000,
            height: 1000
          }
        }
      },
      {
        id: "attwdo7mKNB1YG6FU",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/TLp6RzQcRqR8MQ6ZaeFtpA/Mxe9OE4CumxbYw8EpdsuIMBm_-XZjwLSLUTgii7adQGmT4H2gIdwQCL2R3FrD4LYX46F89BjeoM6uyyMaTl5fml8k0Aq_1ZGVzGGKWSYYqU/ASbjG6-nVFV_vTM083bK7BZR5yh0f3TmeBCgk0NY4uU",
        filename: "sticker-crossclap.jpg",
        size: 91727,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/_qpvf9v8fzT8FI-_htlIeA/giLv30VeRcDruE2aUKtULK8NrjkFlboFr6gVWAsP5vMCEMu4xln0MlNRGFpXVZVoqiSDvvEcewE9V9D6aHdjrusNJBL_2jvR2pFstdpDNhDuhmm-q3tQuuQpDVaUwzqJ/0DVSbwwc6n_dE3xhs3y4XnvkK9Btb3YE34sqDnRdAiA",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/0-sNpJKsgQH6UkN3dc33bQ/VhqRwQRA_zXfPu_ST3YwBhcT46PgMVgs5z8ULrqaELaU7e-dxV6Eh2iM-5oM1lBWIu6-Bb8SO8JkA3I_T3O6FAgJRvTjMoR5SyKT0gJasXdRZoTkopAWTP--clRqgl2e/p0mJDYsNLI3RAeIYvJzjOIfe_j4Z-_3RKA2xQFewn0M",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/q-X_oAl1AsIXSI9kRpblMA/5ACibLiewYoDYU1gGp0j5SzRJ-wj13Y3gnB4IEfoH4gRqQwKANNbBRa9WZbPOqGg2ldGw7Od8biz0qbEWWgAxN1I0je6v5736VvzYV2a2U5LtvTSu1BVu60qpGVvTI_Z/RTrfuBYvhocaSrJWszWYq-3yq6AtRgxKnWC9Xplx04k",
            width: 1000,
            height: 1000
          }
        }
      },
      {
        id: "attPCqkiBiIy7BYbV",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/v7WYhqxpqsDx77X5YJGH1Q/PMk1jXuU9DPxuobYs54xn8vHdmVeJ2EfxxV48cF3O6lbzTkHyXTxGownTMAabJ4W7EziL7xjbgDKaNuRCnRPe7KojOQ9d0LGhoXBf9mrqIU/ofhZX7elIBYfSm1sBTtw3WJpT3sHkdBksSS50bpss0g",
        filename: "sticker-2keys.jpg",
        size: 47762,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/gIA8JGaQqlvWcmCzAh_u1g/kqdwz-_xNbW5yaRC7Bc6XnssA_cEDS8SFxoPoQTfPf2vuJ1KhyRU-DZGR4b7hEMwlRT3stRxLmWi1lCpnoPXoTJWpTb-E2jtAMeqwSs685Ulvio7Ljx5aLcwhoZAhhiH/iOgAq87ECmV_kWYBjwl5xIvnkk7lwn23HPs4CIW6VIA",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/uubKyrRoN7vS6aBwCs0Alw/eLPlk3HB7zRn_y952D5zmkCggzSjwnDTvnnuJqe9Wiv-XjvRZ1ZqBOjpsDjPF36WQygMwoXHJsnIdOsUUamN4Z5V3X4KNsfy34W0BNoBgIF8-dHiWjMBVXjClFZ_lSdf/S60XySEQTXBqyiEP3vUo8a5iaf8dwuUT_NEcuXTNnnM",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/I1zC03wkXqzKkbaYE88gwA/spNQnfWgzBsVcY_S0ku2OqFm9NYOU1tJRCMCYEahMt2apL29dJEzowA_2U_6EK1xR-Uxkyajds0nzW3iNwINxuYmfGhGiE4WTXb77ixXnfE/2VLQZu5pM5y1HiTt9dGxjQPUvTpz6rcJVOYNaXgWTZc",
            width: 1000,
            height: 1000
          }
        }
      }
    ],
    episode: ["recmUBNcwjOKAGc13"],
    category: ["Stickers"],
    price: 6,
    feature_1: "sticky on one side",
    feature_2: "6 stickers in the pack",
    feature_3: "very good at sticking to stuff",
    recommendation_1: "place on your laptop, water bottle, or car",
    recommendation_2: "give as a gift to priest or loved one",
    recommendation_3: "do not eat them, they do not taste very good",
    remaining: 26,
    quantity: 100,
    primary_photo: [
      {
        id: "att9SCghJ5uIEEAYW",
        width: 1000,
        height: 1000,
        url:
          "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/v-O3TspZe4dao0iKcsFbeA/yvzL2Fq7wHtFpUiB-Tg0zborqwHoI4at7ttIZivBSf0VsE5yFY9x96z3PpaQlTi_9C-ktpJ7sncnLWWy0A6F3Byg1Xziyn9ENu6yi05dXLM/7oulivX3FI2igKthGv5no56bt2E0yMlHpc2ICc0nwgE",
        filename: "stickers-group.jpg",
        size: 130895,
        type: "image/jpeg",
        thumbnails: {
          small: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/Jp3nFz2MAXpFBNVwkQmFWA/e7jHkGwVipQE7AeD4ytBEyPBb_RS8W9u5Ec4QYL__W8cDap1iSPHyljLBHdp-TCmUxkSrFGbj3STIVhefQnwqMfSVXAEWRRm8eOCn6uyeKy-Q536zcsEinwqYuiP1oxY/zt0SqqmB5ic3solIaTwckYzz4t_gtdIc0sfFTvKSuCU",
            width: 36,
            height: 36
          },
          large: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/1DQM7WI5Zz0K-tnPBi-vTA/dZnCKTEyCpX8udGbNB7-rJuJMYFZsDqJoAQJZ0EY6Z-TXQ36RL2VToXEsqg88ktjUnfd5a1CmXkCER2tOsjJFJ75xYANROMDxIhA1Ft18s-Cm7co0rZP1z8VU2QrMSfA/UPJ5D4A5EPx7PdCsbAN0eamIbNFnjKhtrgRztuvz5Dc",
            width: 512,
            height: 512
          },
          full: {
            url:
              "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/UraoP-NCd5_b4t1InsRrWQ/gz90k6TxxbPLc1ypJVRpVecxDtCScdAXk6TKwlRxVf32DxFuQTuq3nJh5BZutIDz-NoJiGlMq_2RYrbm2eqZZZvP7OafvyrNJh3NDgYjWxs5zTT3d8T93v1T8O8nyRX_/JUV6cAn7yCl7svt8CbGurp26GD7Hemsqvpmg0B7U7PU",
            width: 1000,
            height: 1000
          }
        }
      }
    ],
    "Order Lines": [
      "recXGIjz2SYLpxumh",
      "rec0BDtnyZ7LcnqJ5",
      "recmrYTeE8TPlMSKL",
      "reciltlLj8Mrsqf1x",
      "recFPo8ku813hUYfO",
      "recUFttH5DnsangtR",
      "recWm0geeZFy8PzUP",
      "recpzx4xAcim4mfvy",
      "recoN6fyKjHbC1OhA",
      "recwLxNnQj6YJ2Crk",
      "rec7c5LDNYe3YGufL",
      "rec95BzYQJZdJp1FC",
      "recRWvzRQvW58e2Si",
      "recaeuZ5DreEffgTp",
      "rec5jbueWX2kAOUlT",
      "rectL7TjeJ0814rDx",
      "recVzQfkHYrGF4DXj",
      "rec2H88Q4Npy3eCJf",
      "recAGP6f1hW2WyPCz",
      "reccHXvBiv8mO1oZS",
      "recmTW8HxKEkKJvGA",
      "rec9SOYtL3OOWvkDX",
      "recJeS1KvKMhxKAvK",
      "rec4TJGeElNApA7Ga",
      "recdzEW7pn4F9UFXt",
      "recw6LnrarjSBzP0a",
      "recCHLbOoqba9PLfc",
      "recDuWGKZrBdane4r",
      "recHDiz2ZcXgPBlnw",
      "recjLLINvtZhZZDj1",
      "recp6WaJ6NytFq8av",
      "recFYxE9M8wOA8DEF",
      "recF3G2cqQCIwY9JP",
      "recpbINj0BQaXFlv6",
      "rec0eORiSvgpZ29RX",
      "recbycTXPhiCmNh9h",
      "recou5a1QfJEDB2mX",
      "rechBlSxPg9LXgcUc",
      "recbrphKwhq2uBoQr",
      "recrGYiEk8NLrmNsJ",
      "recBDgDXcjKOcvLyd",
      "rec5Co3IkaFH8ng6W",
      "recckWM00DuteEpZ1",
      "recQKJgTpVz6VFXlE",
      "recuo199d61MnOjZ4",
      "recM5RP9xZrxrxsWT",
      "recCtBdWScQqzMpnA",
      "recUvRAmVtyJJQXng",
      "recAQl3oHlhb1UA8g"
    ],
    active: [true],
    primaryPhoto:
      "https://v5.airtableusercontent.com/v3/u/27/27/1711605600000/1DQM7WI5Zz0K-tnPBi-vTA/dZnCKTEyCpX8udGbNB7-rJuJMYFZsDqJoAQJZ0EY6Z-TXQ36RL2VToXEsqg88ktjUnfd5a1CmXkCER2tOsjJFJ75xYANROMDxIhA1Ft18s-Cm7co0rZP1z8VU2QrMSfA/UPJ5D4A5EPx7PdCsbAN0eamIbNFnjKhtrgRztuvz5Dc",
    features: [
      "sticky on one side",
      "6 stickers in the pack",
      "very good at sticking to stuff"
    ],
    recommendations: [
      "place on your laptop, water bottle, or car",
      "give as a gift to priest or loved one",
      "do not eat them, they do not taste very good"
    ]
  }
];
